import { render, staticRenderFns } from "./DesignMaterialSidebarMenu.vue?vue&type=template&id=f6060138&scoped=true&"
import script from "./DesignMaterialSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./DesignMaterialSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6060138",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6060138')) {
      api.createRecord('f6060138', component.options)
    } else {
      api.reload('f6060138', component.options)
    }
    module.hot.accept("./DesignMaterialSidebarMenu.vue?vue&type=template&id=f6060138&scoped=true&", function () {
      api.rerender('f6060138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/DesignMaterialSidebarMenu.vue"
export default component.exports